module.exports = __webpack_public_path__ + "static/media/onsoc_small@2x.1cf03525.jpg";